export default __webpack_public_path__ + "static/media/offline-dot.256c5b65.png";